const kinds = {
  1: 'RTC专区',
  4: '班级帖子',
  5: '活动',
  6: '训练营',
  7: '直播',
  8: 'CJ',
  9: '练习',
  10: '复盘'
}
const types = {
  1: '发帖',
  2: '投票',
  3: '直播',
  4: '作业',
  5: '班级发帖',
  6: '学习',
  7: '答疑',
  8: '练习',
  9: '考试',
  10: '课表'
}

// 1文献2课程3病例
const selectCourseTabs = [
  {
    tabName: '文献',
    tabNo: '1'
  },
  {
    tabName: '课程',
    tabNo: '2'
  },
  {
    tabName: '病例',
    tabNo: '3'
  }
]

export {
  kinds,
  types,
  selectCourseTabs
}



// WEBPACK FOOTER //
// ./src/views/cartoJourney/components/data.js